/** Mantine combobox dropdowns above the session sidebar chrome. */
const SESSION_SIDEBAR_COMBOBOX_Z_INDEX = 10_001;
/** Full-width dialogs (e.g. the session scheduler) above the sidebar chrome. */
const SESSION_OVERLAY_MODAL_Z_INDEX = 10_002;
/** Combobox dropdowns opened from inside those dialogs. */
const SESSION_OVERLAY_MODAL_COMBOBOX_Z_INDEX = 10_003;

/** Props for a Mantine Modal shown from the session sidebar, so it stacks above the call chrome. */
export function sessionOverlayModalProps() {
  return {
    modalZIndex: SESSION_OVERLAY_MODAL_Z_INDEX,
    comboboxProps: {
      withinPortal: true,
      zIndex: SESSION_OVERLAY_MODAL_COMBOBOX_Z_INDEX,
      styles: { dropdown: { pointerEvents: 'auto' as const } },
    },
    popoverProps: {
      withinPortal: true,
      zIndex: SESSION_OVERLAY_MODAL_COMBOBOX_Z_INDEX,
    },
  };
}

/** Mantine combobox props so Select dropdowns in the session sidebar render above the call chrome. */
export function sessionSidebarComboboxProps() {
  return {
    withinPortal: true,
    zIndex: SESSION_SIDEBAR_COMBOBOX_Z_INDEX,
    styles: {
      dropdown: {
        pointerEvents: 'auto' as const,
      },
    },
  };
}

/** Mantine popover props so DatePickerInput calendars in the session sidebar render above the call chrome. */
export function sessionSidebarPopoverProps() {
  return {
    withinPortal: true,
    zIndex: SESSION_SIDEBAR_COMBOBOX_Z_INDEX,
  };
}
